<div *ngIf="data != null && data.length > 0" >
  <div class="itemPadding" *ngFor="let x of data">
    <!-- Category -->
    <div appItemDropper
         class="folderName cursor-pointer d-flex"
         [ngClass]="{'selectedFolder' : x.id == selectedFolder, 'hover':hovId == x.id}"
         [draggable]="!['folder.customer', 'folder.technician', 'folder.admin'].includes(x.name)"
         (itemDrop)="itemDrop($event, x.id, x)"
         (dragstart)="dragStart($event, x.id, x)"
         (itemHov)="itemHover($event,x.id)"
         (dragend)="dragEnd($event,x.id)"
         (contextmenu)="contextMenu($event,x)">
      <span *ngIf="!x.showChildren && x.children.length > 0" (click)="x.showChildren = !x.showChildren"><i class="fas fa-chevron-right"></i></span>
      <span *ngIf="x.showChildren && x.children.length > 0" (click)="x.showChildren = !x.showChildren"><i class="fas fa-chevron-down"></i></span>
      <div class=" ml-2" style="user-select:none;" (click)="folderClick(x.id)">
        <span title="{{ x.parentId != null || x.id == 'OS' || !['folder.customer', 'folder.technician', 'folder.admin'].includes(x.name) ? x.name : x.name == 'folder.customer' ? ('Folder.FilesSharedWithCustomer' | translate) : x.name == 'folder.technician' ? ('Folder.FilesSharedInternally' | translate) : ('Folder.FilesSharedWithAdministrators' | translate) }}"
        *ngIf="x.editing == false || x.name == 'root'">{{ 
          !['folder.customer', 'folder.technician', 'folder.admin'].includes(x.name) ? 
           x.name + ( !!x.count ? ' ( ' + x.count + ' )' : '' ) :
          x.name == 'folder.customer' ? 
          ('Folder.Customer' | translate) + (!!x.count ? ' ( ' + x.count + ' )' : '' ) : 
          x.name == 'folder.technician' ? 
          ('Folder.Technician' | translate) + (!!x.count ? ' ( ' + x.count + ' )' : '' ) :
           ('Folder.Administrator' | translate) + (!!x.count ? ' ( ' + x.count + ' )' : '' ) 
          }}</span>
        <span  *ngIf="x.editing == true"><input class="form-control form-control-sm" type="text" [ngModel]="x.name" (change)="renameFolder(x,$event)" (blur)="x.editing = false" /></span>
      </div>
    </div>
    <div class="ml-3" [ngStyle]="{'display' : x.showChildren ? '' : 'none' }">
      <app-image-branch [data]="x.children" [selectedFolder]="selectedFolder" [rightClick]="rightClick" (bubble)="rebubble($event)"></app-image-branch>
    </div>
  </div>
  <div class="contextMenu position-fixed" [ngClass]="showContext ? 'showMe' : '' " [ngStyle]="{'top': context.top, 'left':context.left}" >
    <div class="text-center">{{ context.item?.name | uppercase }}</div>
    <hr>
    <ul class="fileOptions">
      <li (click)="addFolder()">
        <div>{{ 'Standard.NewFolder' | translate }}</div>
      </li>  
      <li (click)="context.item.editing = true">
        <div>{{ 'Folder.Rename' | translate }}</div>
      </li>
      <li (click)="deleteFolder()">
        <div>{{ 'Buttons.Delete' | translate }}</div>
        <span class="text-danger"><i class="fas fa-trash-alt"></i></span>
      </li>
    </ul>
  </div>
</div>
